import objectOf from './objectOf';

// ----------------------------------------------------------------------------

function isObject(value: any): boolean {
    return objectOf(value) === 'Object';
}

// ----------------------------------------------------------------------------

export default isObject;
